import React, { Component } from 'react';
import Button from 'devextreme-react/button';
import DataGrid, {
    Column, ColumnFixing,
    Editing,
    FilterRow,
    HeaderFilter,
    Paging,
    RemoteOperations,
    RequiredRule,
    Scrolling, Sorting
} from "devextreme-react/data-grid";
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import config from "../../../common/config/config";
import { CustomRule } from "devextreme-react/validator";

import { startSync } from '../../../common/syncUtils';

const dataSource = AspNetData.createStore({
    key: 'dealerId',
    loadUrl: `${config.apiUrl}/dealers/dealer-whitelist`,
    insertUrl: `${config.apiUrl}/dealers/dealer-whitelist`,
    updateUrl: `${config.apiUrl}/dealers/dealer-whitelist`,
    deleteUrl: `${config.apiUrl}/dealers/dealer-whitelist`
});

const endpoint = 'job/start/full/dealer-whitelist-import'

class DealerWhitelistComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 0,
            pageLimit: 10,
            totalRecords: 0,
            pageCount: 0,
            pageNeighbours: 2,
            showFilterRow: true,
            showHeaderFilter: true,
            currentFilter: 'auto',
            selectTextOnEditStart: true,
            startEditAction: 'click',
            errors: [],
            isAuthenticated: false,
            user: undefined,
            mode: 'nextColumn',
            readOnly: true,
            height: window.innerHeight - config.pxToSubtract
        };
    }




     handleSync = () => {
        try {
          startSync(endpoint);
        } catch (error) {
          console.error(error);
          
        }
      };


    render() {
        return (
            <div>
                <h1>Dealer Whitelist</h1>
                <div>
                    <ul style={{ listStyleType: "none" }}>
                        {this.state.errors.map((value, index) => {
                            return <li style={{ color: "red" }} key={index}>{value}</li>
                        })}
                    </ul>
                </div>
                <div className="datagrid">
                    <Button text="Sync" onClick={this.handleSync} />

                    <DataGrid id="gridContainer"
                        dataSource={dataSource}
                        showBorders={true}
                        onEditorPreparing={this.onEditorPreparing}
                        keyExpr="id"
                        rowAlternationEnabled={true}
                        showRowLines={true}
                        allowColumnResizing={true}
                        columnResizingMode={'nextColumn'}
                        allowColumnReordering={true}
                        columnAutoWidth={true}
                        height={this.state.height}
                    >
                        <ColumnFixing enabled="true" />
                        <Sorting mode="multiple" />
                        <RemoteOperations paging={true} filtering={true} sorting={true} grouping={true} />
                        <Paging defaultPageSize={config.defaultPageSize} />
                        <Scrolling mode="virtual" rowRenderingMode="virtual" />
                        <Editing
                            mode="batch"
                            allowUpdating={!this.state.readOnly}
                            allowAdding={!this.state.readOnly}
                            allowDeleting={!this.state.readOnly}
                        />
                        <FilterRow visible={this.state.showFilterRow}
                            applyFilter={this.state.currentFilter}
                            showAllText="" />
                        <HeaderFilter visible={this.state.showHeaderFilter} />

                        <Column dataField="dealerNo">
                            <RequiredRule message="Dealer number is required" />
                            <CustomRule reevaluate={true} validationCallback={this.validateDealerNo} message="Dealer No must be 5 symbols length and contain only digits from 0 to 9" />
                        </Column>

                        <Column dataField="groupNo" />

                        <Column dataField="isAllowed" dataType="boolean" allowHeaderFiltering={false} allowFiltering={false} allowEditing={false} />

                        <Column dataField="isPotentialsAllowed" dataType="boolean" allowHeaderFiltering={false} allowFiltering={false} />

                        <Column dataField="isShowcaseDealer" dataType="boolean" allowHeaderFiltering={false} allowFiltering={false}>
                            <CustomRule reevaluate={true} validationCallback={this.validationCallback} message="Is Showcase Dealer field is required" />
                        </Column>
                        <Column dataField="isDxContractActive" dataType="boolean" allowHeaderFiltering={false} allowFiltering={false}>
                            <CustomRule reevaluate={true} validationCallback={this.validationCallback} message="Is Dx Contract Active field is required" />
                        </Column>
                    </DataGrid>
                </div>
            </div>
        );
    };

    validationCallback = (data) => {
        return data.value !== undefined && data.value !== null;
    };

    validateDealerNo = (data) => {
        return /^\d+$/.test(data.value) && data.value.length === 5;
    };

    componentDidMount() {
        fetch(`${config.authUrl}`)
            .then(response => {
                response.json()
                    .then(body => {
                        if (body['authenticated'] === false) {
                            this.setState({ isAuthenticated: false });
                            window.location.reload();
                        } else {
                            this.setState({
                                isAuthenticated: true,
                                readOnly: !body.whitelistReadWrite
                            });
                        }
                    });
            });
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    updateDimensions() {
        this.setState({ height: parseInt(window.innerHeight) - config.pxToSubtract });
    }
}


export default DealerWhitelistComponent;